import { apiErrorMessage } from './ApiError';
import { axiosApi } from './axios.api';
import { UserDataArray, UserModel, UserQueryParams } from '@app/interfaces/user';

const url = `/api/users`;

export interface UserLookupItem {
  id: number;
  name: string;
  email: string;
  avatar_url?: string;
}

/** Endpoint nhẹ cho dropdown — chỉ user đang hoạt động, chỉ tên + avatar. */
export const getUserLookupApi = async (q?: string): Promise<UserLookupItem[]> => {
  try {
    const response = await axiosApi.get<{ rows: UserLookupItem[] }>(`${url}/lookup`, {
      params: q ? { q } : undefined,
    });
    return response.data?.rows ?? [];
  } catch (error: any) {
    apiErrorMessage(error);
    return [];
  }
};

export const getUsersApi = async (params?: UserQueryParams): Promise<UserDataArray | undefined> => {
  try {
    const response = await axiosApi.get<UserDataArray>(url, { params });
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getUserApi = async (userId: number) => {
  try {
    const response = await axiosApi.get(`${url}/${userId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createUserApi = async (data: UserModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateUserApi = async (userId: number, formData: UserModel) => {
  try {
    const response = await axiosApi.put(`${url}/${userId}`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteUserApi = async (userId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${userId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportUserApi = async (params?: Record<string, unknown>) => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });

    const newUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = newUrl;
    link.setAttribute('download', `users.xlsx`);
    document.body.appendChild(link);
    link.click();
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const getActivitiesApi = async (params: string) => {
  try {
    const response = await axiosApi.get(`${url}/activities`, { params });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const uploadUserAvatarApi = async (userId: number, file: File) => {
  try {
    const fd = new FormData();
    fd.append('avatar', file);
    const response = await axiosApi.put(`${url}/${userId}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const lockAcessUserApi = async (userId: number, formData: { status: boolean }) => {
  try {
    const response = await axiosApi.post(`${url}/${userId}/lock_access`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const changePasswordUserApi = async (userId: number, formData: any) => {
  try {
    const response = await axiosApi.post(`${url}/${userId}/change_password`, formData);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.error?.[0] || 'Failed to change password');
  }
};

export const assignEmployeeUserApi = async (userId: number, employeeId: number | null) => {
  try {
    const response = await axiosApi.put(`${url}/${userId}`, { employee_id: employeeId });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const assignRoleUserApi = async (userId: number, formData: {role_ids: string[]}) => {
  try {
    const response = await axiosApi.post(`${url}/${userId}/assign_role`, formData);
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};